import { BrowserRouter , Route, Routes } from "react-router-dom";
import Dashboard from './Components/Home'
import Profile from './Components/Profile'
import Dealer from './Components/Dealer'
import Ticket from './Components/Ticket'
import Charges from './Components/Charges'
import Technician from './Components/Technician'
import Signup from './Components/UnAuthenticated/Signup'
import Signin from './Components/UnAuthenticated/Signin'
import './App.css';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
    <Routes>
    <Route path ="/" element={<Signin/>} />
    <Route path ="/signin" element={<Signin/>} />
    <Route path ="/signup" element={<Signup/>} />
    <Route path ="/dealer" element={<Dealer/>} />
    <Route path ="/ticket" element={<Ticket/>} />
    <Route path ="/charges" element={<Charges/>} />
    <Route path ="/technician" element={<Technician/>} />
    <Route path ="/profile" element={<Profile/>} /> 
    </Routes>
  </BrowserRouter>
    </div>
  );
}

export default App;
